import { useState } from 'react'
import Container from 'react-bootstrap/Container'
import Carousel from 'react-bootstrap/Carousel'
import Image from 'react-bootstrap/Image'
import moment from 'moment'
import ControlLeftIcon from '../../../assets/icons/common/control-left-2.svg'
import ControlRightIcon from '../../../assets/icons/common/control-right-2.svg'
import PersonIcon from '../../../assets/icons/common/person.svg'
import StarIcon from '../../../assets/icons/common/star.svg'
import { Rating } from './Rating'
import './reviews.css'

function SmallSlider({ data = [] }) {
  const [index, setIndex] = useState(0)
  const activeReview = data[index] || data[0] || {}

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex)
  }

  return (
    <section className='ag-testimonials'>
      <Container>
        <div className='ag-testimonials__head'>
          <div>
            <span className='ag-testimonials__eyebrow'>Member feedback</span>
            <h2>Stories from our customers</h2>
          </div>
          <p>
            Real customer comments help new members understand the product
            experience, service quality, and confidence behind Actual Green.
          </p>
        </div>

        <div className='ag-testimonials__shell'>
          <div className='ag-testimonials__summary'>
            <div className='ag-testimonials__icon'>
              <Image src={StarIcon} alt='' />
            </div>
            <strong>{activeReview.rating_stars || 5}.0</strong>
            <span>Average rating from featured reviews</span>
          </div>

          <Carousel
            activeIndex={index}
            className='ag-testimonials__carousel'
            controls
            indicators={false}
            interval={4200}
            pause='hover'
            onSelect={handleSelect}
            prevIcon={
              <span className='ag-testimonials__control'>
                <Image src={ControlLeftIcon} alt='Previous review' />
              </span>
            }
            nextIcon={
              <span className='ag-testimonials__control'>
                <Image src={ControlRightIcon} alt='Next review' />
              </span>
            }
          >
            {data.map((review, i) => (
              <Carousel.Item key={review.id || i}>
                <article className='ag-testimonials__card'>
                  <div className='ag-testimonials__quote-mark'>"</div>
                  <Rating count={review.rating_stars} />
                  <blockquote>{review.comment}</blockquote>
                  <div className='ag-testimonials__author'>
                    <div className='ag-testimonials__avatar'>
                      <Image src={PersonIcon} alt='' />
                    </div>
                    <div>
                      <cite>{review.customer_name}</cite>
                      <time>
                        Shared {moment(review.date).format('MMMM YYYY')}
                      </time>
                    </div>
                  </div>
                </article>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>

        <div className='ag-testimonials__people'>
          {data.slice(0, 5).map((review, i) => (
            <button
              className={`ag-testimonials__person ${
                index === i ? 'is-active' : ''
              }`}
              key={review.id || i}
              onClick={() => setIndex(i)}
              type='button'
            >
              <span>{review.customer_name?.slice(0, 1) || 'A'}</span>
              <strong>{review.customer_name}</strong>
            </button>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default SmallSlider
